"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceTypeNameEnum = void 0;
var SourceTypeNameEnum;
(function (SourceTypeNameEnum) {
    SourceTypeNameEnum["SITE"] = "\u0421\u0430\u0439\u0442";
    SourceTypeNameEnum["MOBILE"] = "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435";
    SourceTypeNameEnum["ADMIN"] = "\u0410\u0434\u043C\u0438\u043D\u043A\u0430";
    SourceTypeNameEnum["TERMINAL"] = "\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B";
    SourceTypeNameEnum["IIKO"] = "IIKO";
})(SourceTypeNameEnum = exports.SourceTypeNameEnum || (exports.SourceTypeNameEnum = {}));
//# sourceMappingURL=SourceTypeNameEnum.js.map